import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVisionProApp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconVisionProApp"><Path fillRule="evenodd" clipRule="evenodd" d="M3 4H23V17.9286H20V20H6V17.9286H3V4ZM7.5 17V18.5H18.5V17H7.5ZM1.5 8V14H0V8H1.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVisionProApp;
